import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";

import { AlertError, IsEmptyArray } from "../../core/Helper";

import { FormObjectService } from "../../core/FieldObject";

import {
  ConfirmsDeleteAction,
  DefaultBillViewer,
  DefaultEditorValue,
  GetCreateTable,
  GetEditorForm,
  ShowsEditor,
} from "../../core/Helper2";
import { DocumentService } from "../../model/backoffice/document";

import {
  GetReceipteHeaderObject,
  GetReceiptFooterObject,
  GetReceiptPaymentObject,
} from "../../core/BillingRecieptComponent";
import { BuildsColumnsWithEdit } from "../../core/TableHelper";
import { TopToolBar } from "../../core/TopToolbar";

import PaymentEditor from "./0031_payment-editor";

import { IsCanDelete, UserRight, UserRightChecker } from "../../core/Helper3";
import SearchBigData, { DefaultState } from "../components/SearchBigData";
import ConfirmDialogB, { ConfirmDefault } from "../components/ConfirmDialogB";
import { SearchCustomer } from "../../model/customer";
import {
  CalcSummary,
  GetRunningDocu,
  LoadCustomer,
  LoadDocuList,
} from "../../core/BillingComponents";
import { FormType } from "../../model/backoffice/document-type";
import BillViewer, {
  FormDocuType,
} from "../../components/bill-forms/BillViewer";
import FormAutoObject from "../../core/FormAutoObject";

/**
 * Main Invoice form ....
 * @param {*} props
 * @returns
 */
export default function FormReceipt(props) {
  const documentIdFieldName = "ReceiptId";
  const documentItemIdFieldName = "ReceiptPaymentId";
  const userInfo = useSelector((state) => state.user);
  const ref1 = useRef();
  const ref2 = useRef();
  const [form, setForm] = useState();
  const [objHead, setObjHead] = useState(null);
  const [objSum, setObjSum] = useState(null);

  const [docuList, setDocuList] = useState([]);
  const [runningDocu, setRunningDocu] = useState();
  const [billViewer, setBillViewer] = useState(DefaultBillViewer);
  const [data, setData] = useState({});
  const [editor, setEditor] = props.editor;
  const [loading, setLoading] = useState(false);
  const [searchBig, setSearchBig] = useState(DefaultState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (editor?.show) {
      //console.clear();
      setSearchBig(DefaultState);
      LoadDocuList([userInfo.detail, setDocuList], FormType.RECEIPT);

      return () => {
        setDocuList([]);
        setBillViewer(null);
        setRunningDocu(null);
        setForm(null);
        setObjHead(null);
        setObjSum(null);
        setSearchBig(null);

        setData({});
      };
    }
  }, [editor?.show]);

  /** CREATE OLD PRINT REPORT DATA */
  useEffect(() => {
    if (editor?.show && docuList) {
      const loadOld = async () => {
        setLoading(true);
        await checkExistReceipt([editor, userInfo.detail, setData]);
        setLoading(false);
      };
      loadOld();
    }
  }, [docuList]);

  // เปลี่ยนเลขที่เอกสาร
  useEffect(() => {
    if (editor?.show && data?.DocuBranch) {
      // check old document-id
      let invId = data?.[documentIdFieldName];
      if (!invId) {
        // get latest running no if no invoice-id isfound
        if (data?.[documentIdFieldName] <= 0) {
          GetRunningDocu([data, setData, userInfo.detail, setRunningDocu]);
        }
      }
    }
  }, [data?.DocuBranch]);

  // * Discount effected. เมื่อมีการระบุส่วนลด หรือภาษีหัก ณ ที่จ่าย
  useEffect(() => {
    if (editor?.show) {
      if (data?.Discount !== undefined) {
        CalcSummary([
          runningDocu,
          sumItem,
          data,
          setData,
          editor?.invoiceInfo?.Study?.StudyItems,
        ]);
      }
    }
  }, [data?.Discount, data?.HoldingTaxRate, runningDocu]);

  /** SAVE  */
  const actionSave = async () => {
    let saveInfo = {
      ...data,
      DocuBranch: runningDocu ?? data.DocuBranch,
      Invoice: { DocuInvoiceId: editor.invoiceInfo?.DocuInvoiceId },
      Study: {
        PacsStudyId: editor.invoiceInfo.Study,
      },
    };

    setEditor((pv) => ({ ...pv, wait: true }));
    let res = await DocumentService.SaveReceipt(saveInfo, userInfo.detail);

    setEditor((pv) => ({ ...pv, wait: false }));
    if (res) {
      if (res?.Message == "Error") {
        AlertError(res?.Data ?? "พบปัญหาการบันทึก", dispatch);
        return;
      }

      setData(res);
    }
  };

  const printAction = async () => {
    setBillViewer((pv) => ({
      ...pv,
      show: true,
      formDocuType: FormDocuType.RECEIPT,
    }));
  };

  /** Customer  */
  const custClick = (item) => {
    SearchCustomer(
      [setSearchBig, data, setData, userInfo.detail, item],
      async (result) => {
        await LoadCustomer(result?.custid, [userInfo.detail, setData]);
        setSearchBig((pv) => ({ ...pv, show: false }));
      }
    );
  };

  const buildObjHead = async () => {
    if (!editor?.show) return;

    setObjHead(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetReceipteHeaderObject({
              doculist: docuList,
              docuFieldIdName: documentIdFieldName,
              head: data,
              custClick,
            })
          ),
          dataValue: [data, setData],
          refTo: ref1,
        }}
      />
    );
  };

  const buildObjSum = async () => {
    if (!editor?.show) return;

    setObjSum(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetReceiptFooterObject({})
          ),
          dataValue: [data, setData],
          refTo: ref2,
        }}
      />
    );
  };

  useEffect(() => {
    if (editor?.show && data) {
      buildObjHead();
      buildObjSum();
    }
  }, [data, billViewer]);

  const [paymentsTb, setPaymentsTb] = useState(); //
  const [paymentEditor, setPaymentEditor] = useState(DefaultEditorValue);
  const [confirm, setConfirm] = useState(ConfirmDefault);

  //** เพิ่มวิธีการจ่ายเงิน */
  const addNewPayment = () => {
    ShowsEditor(setPaymentEditor, documentItemIdFieldName, 0, (row) =>
      updatePaymentData(row)
    );
  };

  //** แก้ไขรายการรับเงิน
  const editPayment = (cell, row) => {
    ShowsEditor(
      setPaymentEditor,
      documentItemIdFieldName,
      0,
      (row) => updatePaymentData(row),
      null,
      row
    );
  };

  // คลิกปุ่มลบรายการรับเงิน
  const deletePayment = (col, row) => {
    if (row[documentItemIdFieldName] > 0) {
      if (!IsCanDelete(userInfo.userRule, dispatch)) return;
      ConfirmsDeleteAction(setConfirm, async () => {
        let res = await DocumentService.DeletePaymentItem(
          { [documentItemIdFieldName]: row[documentItemIdFieldName] },
          userInfo.detail
        );
        if (res) {
          removePaymentRow(row);
        }
      });
    } else {
      removePaymentRow(row);
    }
  };

  //** ลบแถวออกจากตาราง */
  const removePaymentRow = (row) => {
    setData((pv) => {
      pv.RecieptPayments = pv?.RecieptPayments?.filter(
        (r) => r[documentItemIdFieldName] !== row[documentItemIdFieldName]
      );
      return { ...pv };
    });
  };

  /** ปรับปรุงรายการหลังจาก call-back บันทึกรายการับเงิน */
  const updatePaymentData = (row) => {
    setData((pv) => {
      let ret = null;
      let RecieptPayments = pv.RecieptPayments ?? [];
      if (row?.[documentItemIdFieldName] === 0) {
        let n = -1;
        let cnt = 0;

        while (!IsEmptyArray(ret) && cnt < 10) {
          ret = data.RecieptPayments?.filter(
            (r) => Number(r[documentItemIdFieldName]) === Number(n)
          );
          if (IsEmptyArray(ret) || ret === undefined) {
            //สร้าง Id เทียม -1, -2, -3 ....
            row[documentItemIdFieldName] = n;
            RecieptPayments = [...RecieptPayments, row];
            pv.RecieptPayments = RecieptPayments;
            return { ...pv };
          }
          n--;
          cnt++;
        }
      } else {
        for (var i = 0; i < pv.RecieptPayments.length; i++) {
          if (
            pv.RecieptPayments[i][documentItemIdFieldName] ===
            row[documentItemIdFieldName]
          ) {
            pv.RecieptPayments[i] = { ...pv.RecieptPayments[i], ...row };
            return { ...pv };
          }
        }
      }
      return { ...pv };
    });
    setPaymentEditor(DefaultEditorValue);
  };

  /** Effected Data changed... */
  useEffect(() => {
    if (editor?.show) {
      let columns = BuildsColumnsWithEdit(
        GetReceiptPaymentObject({}),
        editPayment,
        deletePayment
      );
      setPaymentsTb(
        GetCreateTable({
          idFieldName: "ReceiptPaymentId",
          columns: columns,
          data: data?.RecieptPayments ?? [],
          wrapperClasses: "table-wrapper-min-height",
        })
      );
    }
  }, [data]);

  useEffect(() => {
    if (editor?.show && !objHead && !objSum) return;
    setsForms();
  }, [
    editor?.show,
    objHead,
    objSum,
    searchBig,
    paymentEditor,
    paymentsTb,
    confirm,
  ]);

  // สร้างฟอร์ม
  const setsForms = async () => {
    setForm(
      <div>
        <DivMain>
          <DivLeft>{objHead}</DivLeft>
          <DivRight>{objSum}</DivRight>
          <BillViewer
            {...{
              billViewer: [billViewer, setBillViewer],
              data: [data, setData],
            }}
          ></BillViewer>
        </DivMain>
        <DivBottom>
          <TopToolBar
            disableEmpty={true}
            onAddNew={addNewPayment}
            title={"รายการรับเงิน"}
          ></TopToolBar>
          {paymentsTb}
        </DivBottom>
        <PaymentEditor
          {...{
            editor: [paymentEditor, setPaymentEditor],
          }}
        />
        <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
        <SearchBigData {...{ winState: [searchBig, setSearchBig] }} />
      </div>
    );
  };

  return (
    <>
      {form ? (
        <GetEditorForm
          {...{
            title: `ออกเอกสารรับเงิน`,
            editor: [editor, setEditor],
            form: [form, setForm],
            saveData: actionSave,
            size: "xl",
            saveButtonTitle: data === null ? "บันทึกใบเสร็จ" : "แก้ไขใบเสร็จ",
            print: {
              action: printAction,
              disabled: false,
              // hidden: head?.[documentIdFieldName] === 0,
              hidden: data === null,
            },
          }}
        ></GetEditorForm>
      ) : (
        <></>
      )}
    </>
  );
}

//** Sum price from study item */
const sumItem = ([StudyItems]) => {
  let amnt = 0;
  if (StudyItems?.length > 0) {
    StudyItems?.map((r) => {
      amnt = amnt + Number(r.Total);
    });
  }
  return amnt;
};

//** Load Lastest issued invoice */
const checkExistReceipt = async ([editor, userInfo, setData]) => {
  let recipt = await DocumentService.GetReceiptedInvoice(
    { DocuInvoiceId: editor?.invoiceInfo?.DocuInvoiceId },
    userInfo.detail
  );

  // return;
  if (recipt && recipt.length > 0) {
    let cInv = recipt[recipt.length - 1];
    // setData(cInv);
    setData(cInv);
    return true;
  } else {
    const {
      Customer,
      BillAddr1,
      BillAddr2,
      BillTo,
      Study,
      Amount,
      Discount,
      NetTotal,
      Total,
      VatRate,
      VatTotal,
      BillPhone,
    } = editor.invoiceInfo;

    setData((pv) => ({
      ...pv,
      ...{
        Customer,
        Study,
        BillAddr1,
        BillAddr2,
        BillTo,
        Amount,
        Discount,
        NetTotal,
        Total,
        VatRate,
        VatTotal,
        BillPhone,
      },
    }));
    return false;
  }
};

const DivMain = styled.div`
  display: flex;
`;

const DivLeft = styled.div`
  flex: 1;
  width: 100%;
`;
const DivRight = styled.div`
  width: 300px;
`;

const DivBottom = styled.div`
  flex: 1;
  width: 100%;
`;
